// extracted by mini-css-extract-plugin
module.exports = {"workspaceURLField":"CreateWorkspacePage_workspaceURLField__2JYRt","suffix":"CreateWorkspacePage_suffix__3JDNA","hover-ripples":"CreateWorkspacePage_hover-ripples__3h59z"};